export enum TooltipStyleEnum {
    DANGER = 'DANGER',
    DEFAULT = 'DEFAULT',
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
}
